import useHomeProperties from "@/hooks/common/useHomeProperties";
const { modelNumberFormat = '' } = useHomeProperties();

const defaultTransform = (modelNumber) => {
  return String(modelNumber ?? '').replace(/\s+/g, '').toUpperCase();
};

const FUNCTION_REGEX = /^(function\s*(\(|[\w$]+\s*\()|\(.*\)\s*=>|async\s*(function|\([\w\s,]*\)\s*=>))/;
const BLACKLIST_KEYWORDS = [
  'eval', 'Function', 'setTimeout', 'setInterval',
  'XMLHttpRequest', 'fetch', 'import', 'require',
  'window', 'document', 'globalThis', 'self',
  'localStorage', 'sessionStorage', 'cookie',
  'constructor', '__proto__', 'prototype',
  'process', 'module', 'exports',
];
const BLACKLIST_REGEX = new RegExp(`\\b(${BLACKLIST_KEYWORDS.join('|')})\\b`);

const safeExecuteFunction = (fnString, ...args) => {
  if (!fnString || typeof fnString !== 'string') {
    return defaultTransform(...args);
  }

  const trimmed = fnString.trim();

  if (!FUNCTION_REGEX.test(trimmed)) {
    return defaultTransform(...args);
  }

  if (BLACKLIST_REGEX.test(trimmed)) {
    return defaultTransform(...args);
  }

  try {
    const argNames = args.map((_, i) => `arg${i}`);
    const fn = new Function(
      ...argNames,
      `"use strict";
       return (${trimmed}).apply(this, arguments);`
    );
    return fn(...args);
  } catch (e) {
    return defaultTransform(...args);
  }
};

export default (modelNumber) => {
  return safeExecuteFunction(modelNumberFormat, modelNumber);
};


